import React, { useState } from 'react';
import './career.css';
import Footer from '../components/footer';
import CareerForm from '../components/CareerForm';
import { Helmet } from 'react-helmet';
import Consultant from '../components/consultant';
import Breadcrumbs from '../components/breadcrumb';

const careerSearchImg = `/images/career-serach.png`;
const creativeIcon = `/images/creative.svg`;
const politicsIcon = `/images/politics.svg`;
const discussionIcon = `/images/discussion.svg`;

function Career() {
    const [inputKeyword, setInputKeyword] = useState('');
    const [keyword, setKeyword] = useState('');
    const [location, setLocation] = useState('');
    const [profile, setProfile] = useState('');
    const [jobDetails, setJobDetails] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [showApplyForm, setShowApplyForm] = useState(false);
    const [applicationData, setApplicationData] = useState({
        name: '',
        email: '',
        phone: '',
        post: '',
        experience: 'fresher',
        about: '',
        cv: null,
        captcha: ''
    });

    // const jobs = [
    //     { title: "Frontend Developer", location: "Noida", profile: "Developer", description: "Develop frontend applications using React.", requirements: "Experience in React, CSS, HTML, JavaScript.", salary: "$70,000 - $90,000" },
    //     { title: "Graphic Designer", location: "Noida", profile: "Designer", description: "Create stunning visuals for digital marketing.", requirements: "Proficiency in Adobe Creative Suite.", salary: "$50,000 - $70,000" },
    //     { title: "Project Manager", location: "Noida", profile: "Manager", description: "Manage team projects and resources.", requirements: "Experience in project management and team leadership.", salary: "$80,000 - $100,000" },
    //     { title: "Backend Developer", location: "Noida", profile: "Developer", description: "Develop backend APIs using Node.js.", requirements: "Strong Node.js and database skills.", salary: "$75,000 - $95,000" },
    //     { title: "UI/UX Designer", location: "Noida", profile: "Designer", description: "Design user interfaces and experiences.", requirements: "Knowledge of design tools and wireframing.", salary: "$60,000 - $80,000" }
    // ];

    const jobs = [
        {
    title: "Full Stack .NET Developer (React.js)",
    employmentType: "Contract-Based",
    experience: "4+ Years",
    location: "Remote",
    profile: "Developer",
    description: "We are building a pool of experienced Full Stack .NET Developers (4+ years) for remote, contract-based roles. The ideal candidates will have strong backend expertise in .NET Core and frontend experience with React.js, along with solid database and cloud deployment skills.",
    keyResponsibilities: [
        "Develop and maintain scalable full-stack web applications using .NET Core and React.js",
        "Build and consume RESTful APIs using C#",
        "Design and optimize relational databases using SQL Server or MySQL",
        "Collaborate with UI/UX teams to create responsive, user-friendly interfaces",
        "Participate in code reviews, testing, and Agile ceremonies",
        "Troubleshoot, debug, and resolve application issues",
        "Deploy applications on Microsoft Azure using CI/CD pipelines"
    ],
    requiredSkills: {
        "Backend (.NET & APIs)": [
            ".NET Core, ASP.NET MVC, C#",
            "RESTful API development",
            "Entity Framework or Dapper"
        ],
        "Frontend (React.js)": [
            "React.js with Redux or Context API",
            "HTML5, CSS3, Bootstrap",
            "JavaScript (ES6+) or TypeScript"
        ],
        "Database": [
            "SQL Server or MySQL (mandatory)",
            "MongoDB, Redis (nice to have)"
        ],
        "Cloud & DevOps": [
            "Microsoft Azure (App Services, SQL, Storage)",
            "Git (mandatory), CI/CD with Azure DevOps, GitHub Actions, or Jenkins (nice to have)",
            "Docker (basic knowledge preferred)",
            "AWS or Google Cloud Platform (GCP) – nice to have"
        ]
    },
    qualifications: [
        "Bachelor’s or Master’s in Computer Science, Engineering, or related field",
        "4+ years of hands-on full-stack development experience",
        "Strong problem-solving and communication skills",
        "Experience working in Agile/Scrum teams"
    ],
    mailUs: "careers@stamenssoftware.com"
},
        {
    title: "Full Stack .NET Developer (Angular)",
    employmentType: "Contract-Based",
    experience: "4+ Years",
    location: "Remote",
    profile: "Developer",
    description: "We are building a pool of experienced Full Stack .NET Developers (4+ years) for remote, contract-based roles. The ideal candidates will have strong backend expertise in .NET Core and frontend experience with Angular, along with solid database and cloud deployment skills.",
    keyResponsibilities: [
        "Develop full-stack web applications using .NET Core, C#, ASP.NET MVC, and Angular (v10+)",
        "Build and maintain RESTful APIs for seamless integration",
        "Manage data interactions with SQL Server and MySQL",
        "Collaborate with designers to implement responsive and user-friendly UIs",
        "Participate in Agile ceremonies, code reviews, and unit testing",
        "Troubleshoot and resolve issues in development and production environments",
        "Deploy and monitor applications using Microsoft Azure and CI/CD pipelines"
    ],
    requiredSkills: {
        "Backend (.NET & APIs)": [
            ".NET Core, ASP.NET MVC, C#",
            "RESTful API development",
            "Entity Framework or Dapper"
        ],
        "Frontend (Angular)": [
            "Angular (v10+), TypeScript",
            "HTML5, CSS3, Bootstrap"
        ],
        "Database": [
            "SQL Server or MySQL (mandatory)",
            "MongoDB, Redis (nice to have)"
        ],
        "Cloud & DevOps": [
            "Microsoft Azure (App Services, SQL, Storage)",
            "Git (mandatory), CI/CD using Azure DevOps, GitHub Actions, or Jenkins (nice to have)",
            "Docker (basic knowledge preferred)",
            "AWS or Google Cloud Platform (GCP) – nice to have"
        ]
    },
    qualifications: [
        "Bachelor’s or Master’s in Computer Science, Engineering, or related field",
        "4+ years of hands-on full-stack development experience",
        "Strong problem-solving and communication skills",
        "Experience working in Agile/Scrum teams"
    ],
    mailUs: "careers@stamenssoftware.com"
},
        {
            title: ".Net Python Developer",
            employmentType: "Contract",
            experience: "4yrs - 7yrs",
            location: "Remote",
            profile: "Developer",
            description: "We’re looking for a talented .NET Python Developer with strong experience in Python to join our remote team. This role requires a combination of backend development expertise, solid programming skills, and the ability to deliver efficient, scalable, and high-performance applications.",
            keyResponsibilities: [
                ".NET Development: Strong experience with C#, .NET Core, ASP.NET MVC, Web API, Entity Framework",
                "Python Development: Experience with Python frameworks like Django, Flask, or FastAPI",
                "Proficient in writing unit tests (xUnit, NUnit for .NET, PyTest for Python)",
                "Experience with database management systems like SQL Server, MySQL, PostgreSQL",
                "Familiarity with version control systems like Git",
                "Strong understanding of RESTful API principles and microservices architecture",
                "Experience with CI/CD tools and pipelines (e.g., Jenkins, Azure DevOps)",
                "Understanding of Agile/Scrum methodologies",
                "Strong Verbal and written communication skills",
                "Exposure to front-end technologies like HTML, CSS, and JavaScript",
                "Understanding of DevOps practices and tools"
            ],
            mailUs:"careers@stamenssoftware.com"
        },
        {
            title: ".Net Java Developer",
            employmentType: "Contract",
            experience: "4yrs - 7yrs",
            location: "Remote",
            profile: "Developer",
            description: "We’re looking for a talented .NET Java Developer with strong experience in JAVA to join our remote team. The ideal candidate will possess strong expertise in both .NET technologies and Java development, working with modern frameworks and libraries. This role demands solid backend development capabilities, clean coding practices, and the ability to build efficient, scalable, and high-performance applications.",
            keyResponsibilities: [
                "Develop, test, and deploy applications using .NET and Java, with a focus on core backend development and API integrations",
                "Write clean, modular, and reusable code using C# (.NET Core/ASP.NET MVC) and Java (Spring Boot/Hibernate)",
                "Debug, troubleshoot, and optimize application performance for scalability and reliability",
                "Ensure security and data protection across both .NET and Java applications"
            ],
            mailUs: "careers@stamenssoftware.com"
        },
        {
    title: "Java Developer",
    employmentType: "Contract-Based",
    experience: "5+ Years",
    location: "Remote",
    profile: "Developer",
    description: "We are building a pool of experienced Java Developers (5+ years) for remote, contract-based roles. Candidates should have strong backend development expertise using modern Java frameworks, with added advantage for those with full-stack skills and experience deploying applications on cloud platforms.",
    keyResponsibilities: [
        "Develop and maintain scalable, high-performance Java applications.",
        "Design and implement REST APIs and microservices using Spring Boot.",
        "Collaborate with cross-functional teams for solution design and delivery.",
        "Integrate applications with databases, third-party tools, and services.",
        "Write clean, testable, and well-documented code following best practices.",
        "Participate in code reviews, debugging, and performance optimization.",
        "Deploy applications to cloud environments using CI/CD pipelines.",
        "Contribute to Agile development processes and regular team meetings."
    ],
    requiredSkills: {
        "Backend (Core Java & Frameworks)": [
            "Java (8/11/17+), Spring Boot, Spring MVC, Spring Cloud, Spring Security",
            "Hibernate / JPA, Jakarta EE",
            "REST APIs, Microservices Architecture"
        ],
        "Database": [
            "MySQL or PostgreSQL (mandatory)",
            "Oracle, MongoDB, Redis (nice to have)"
        ],
        "DevOps & Cloud": [
            "Git, Maven or Gradle (mandatory); Jenkins, GitHub Actions (nice to have)",
            "Docker, Kubernetes (basic knowledge)",
            "Experience with AWS / Azure / GCP"
        ],
        "Frontend Skills (Optional but Preferred)": [
            "JSP, Thymeleaf (Java templating)",
            "Angular, React.js, Vue.js",
            "HTML, CSS, Bootstrap"
        ],
        "Nice to Have": [
            "Struts, JSF, EJB (legacy knowledge)",
            "Kafka, RabbitMQ (messaging)",
            "ELK Stack, Prometheus, Grafana (logging/monitoring)"
        ]
    },
    qualifications: [
        "Bachelor’s or Master’s in Computer Science/Engineering",
        "5+ years of Java development experience",
        "Good problem-solving, communication, and teamwork skills"
    ],
    mailUs: "careers@stamenssoftware.com"
}
    ];

    const filteredJobs = jobs.filter(job => {
        return (
            (!location || job.location === location) &&
            (!profile || job.profile === profile) &&
            (!keyword || job.title.toLowerCase().includes(keyword.toLowerCase()) || job.description.toLowerCase().includes(keyword.toLowerCase()))
        );
    });

    const handleJobClick = (job) => {
        setJobDetails(job);
        setShowDetails(true);
    };

    const handleBackToList = () => {
        setShowDetails(false);
        setJobDetails(null);
        setShowApplyForm(false);
        setApplicationData({
            name: '',
            email: '',
            phone: '',
            post: '',
            experience: 'fresher',
            about: '',
            cv: null,
            captcha: ''
        });
    };

    const handleSearchClick = () => {
        setKeyword(inputKeyword);
    };

    const handleApplyClick = (job) => {
        setJobDetails(job);
        setShowApplyForm(true);
    };

    const handleApplyClick2 = () => {
        setShowApplyForm(true);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setApplicationData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        setApplicationData(prevState => ({
            ...prevState,
            cv: e.target.files[0]
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <>
            <Helmet>
                <title>Careers | Stamens Software - Join Our Growing IT Team</title>
                <meta name="description" content="Explore exciting career opportunities at Stamens Software. Join a dynamic, innovative IT company in Noida and be part of a team that creates cutting-edge software and technology solutions. Apply now!" />
                <meta name="keywords" content="Careers, Jobs, IT Careers, Software Development Jobs, Web Development Jobs, Technology Jobs, Work at Stamens Software, Noida Careers, Join Our Team" />
            </Helmet>

            <section className="custom-banner">
                <div className="container">
                    <h1 className="banner-head text-center">
                        <span>Career at Stamens</span>
                        An Opportunity to Learn & Create
                    </h1>
                    <h2 className="available-job"><span>{filteredJobs.length}</span> Jobs Available Now</h2>
                    <div className="banner-search">
                        <div className="back-sec">
                            <input
                                type="text"
                                placeholder="Search Keywords"
                                value={inputKeyword}
                                onChange={(e) => setInputKeyword(e.target.value)}
                            />
                            <select value={location} onChange={(e) => setLocation(e.target.value)}>
                                <option value="">Select Location</option>
                                <option value="Remote">Remote</option>
                                <option value="Noida">Noida, UP, India</option>
                                {/* <option value="Faridabad">Faridabad, HR, India</option> */}
                                {/* <option value="Chicago">Chicago</option> */}
                            </select>
                            <button onClick={handleSearchClick}>
                                <i className="fa fa-magnifying-glass"></i> Search
                            </button>
                        </div>
                    </div>
                    <Breadcrumbs />
                </div>
            </section>

            <div className="container">
                <div className="filter">
                    <div className="name">Filter by</div>
                    <div className="location">
                        <label htmlFor="sidebarLocation">Location:</label>
                        <select value={location} onChange={(e) => setLocation(e.target.value)}>
                            <option value="">All Locations</option>
                            <option value="Remote">Remote</option>
                            <option value="Noida">Noida, UP, India</option>
                            {/* <option value="Faridabad">Faridabad, HR, India</option> */}
                            {/* <option value="Chicago">Chicago</option> */}
                        </select>
                    </div>
                    <div className="profile">
                        <label htmlFor="sidebarProfile">Profile:</label>
                        <select value={profile} onChange={(e) => setProfile(e.target.value)}>
                            <option value="">All Profiles</option>
                            <option value="Developer">Developer</option>
                            <option value="Designer">Designer</option>
                            <option value="Manager">Manager</option>
                        </select>
                    </div>
                </div>

                <div className="job-list">
                    {showDetails && !showApplyForm ? (
                       <div id="jobDetailsSection">
    <div className="details">
        <h3>{jobDetails.title}</h3> {/* ✅ RIGHT */}
        <p><strong>Employment Type:</strong> {jobDetails.employmentType}</p>
        <p><strong>Experience:</strong> {jobDetails.experience}</p>
        <p><strong>Location:</strong> {jobDetails.location}</p>
        <p><strong>Profile:</strong> {jobDetails.profile}</p>
        <p><strong>Job Overview:</strong> {jobDetails.description}</p>

        {Array.isArray(jobDetails.keyResponsibilities) && (
            <>
                <p><strong>Key Responsibilities:</strong></p>
                <ul>
                    {jobDetails.keyResponsibilities.map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </ul>
            </>
        )}

        {jobDetails.requiredSkills && (
            <>
                <p><strong>Required Skills:</strong></p>
                {Object.entries(jobDetails.requiredSkills).map(([category, skills], idx) => (
                    <div key={idx}>
                        <strong>{category}:</strong>
                        <ul>
                            {skills.map((skill, i) => (
                                <li key={i}>{skill}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </>
        )}

        {Array.isArray(jobDetails.qualifications) && (
            <>
                <p><strong>Qualifications:</strong></p>
                <ul>
                    {jobDetails.qualifications.map((qual, idx) => (
                        <li key={idx}>{qual}</li>
                    ))}
                </ul>
            </>
        )}

        <p><strong>Send your CV to:</strong> {jobDetails.mailUs}</p>
        <button className="btn btn-primary" style={{ marginRight: '5px' }} onClick={handleApplyClick2}>Apply</button>
        <button className="btn btn-primary" onClick={handleBackToList}>Back to Job List</button>
    </div>
</div>


                    ) : showApplyForm ? (
                        <div className="apply-form" id='form'>
                            <div className="head">Apply for {jobDetails?.title}</div>
                            <CareerForm title={jobDetails?.title} />
                            <button className="btn btn-primary mt-3" onClick={handleBackToList}>Back to Job List</button>
                        </div>
                    ) : (
                        filteredJobs.length > 0 ? (
                            filteredJobs.map((job, index) => (
                                <div key={index} className="job-item">
                                    <h4>{job.title}</h4>
                                    <p><strong>Employment Type:</strong> {job.employmentType}</p>
                                    <p><strong>Experience:</strong> {job.experience}</p>
                                    <p><strong>Location:</strong> {job.location}</p>
                                    <p><strong>Profile:</strong> {job.profile}</p>
                                    <p>{job.description}</p>
                                    <button className="btn btn-primary" onClick={() => handleJobClick(job)}>View More Details</button>
                                    <button className="btn btn-primary" style={{ marginLeft: '5px' }} onClick={() => handleApplyClick(job)}>Apply</button>
                                </div>
                            ))
                        ) : (
                            <div className="no-results">
                                <p>No results found</p>
                            </div>
                        )
                    )}
                </div>
            </div>

            <Consultant sectionClass={'consultation'} />

            <section className="culture">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-5">
                            <div className="imgarea">
                                <img src={careerSearchImg} alt="career search" className="img-fluid rounded" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="content-part">
                                <h2 className="head">
                                    <span>Work Culture</span>
                                    We Provide Best Career Solutions
                                </h2>
                                <div className="part">
                                    <img src={creativeIcon} height="100" width="100" alt="creative icon" className="img-fluid" />
                                    <div>
                                        <h3>Creative</h3>
                                        <p>We always believe in Out of the Box thinking and it clearly shows in our Work Culture. Our workspace promotes young innovative thinking. “Think Quality & Think Creative”.</p>
                                    </div>
                                </div>
                                <div className="part">
                                    <img src={politicsIcon} height="100" width="100" alt="no politics icon" className="img-fluid" />
                                    <div>
                                        <h3>No-Politics</h3>
                                        <p>At Stamens Software, we do not tolerate or promote any kind of politics, personal or professional. Come, work, learn and laugh with us, and benefit from the expert assistance available anytime for your queries.</p>
                                    </div>
                                </div>
                                <div className="part">
                                    <img src={discussionIcon} height="100" width="100" alt="discussion icon" className="img-fluid" />
                                    <div>
                                        <h3>Discussion Oriented</h3>
                                        <p>Our work culture is based on positive coordination and discussion between young minds to bring out the best and innovational ideas. Healthy discussions are the means of sharing and building ideas.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>

    )
}

export default Career;